// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3cYXs","text":"SelectPayment_text__3SCR7","title":"SelectPayment_title__2XRU3","btn":"SelectPayment_btn__KpzQs"};